import { ScrollArea } from "../../ScrollArea/index.js";
import { ListItem } from "./ListItem.js";
import { useEffect, useRef } from "react";
import { IconLoader } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { useVirtualizer } from "@tanstack/react-virtual";
//#region src/Select/local-components/List.tsx
const ROW_HEIGHT_PX = 40;
const List = ({ items, className, visibleItemsCount = 6, minVisibleItemsCount, search, onScrollEnd, hasNextPage, isFetching, fetchItemTooltip }) => {
	const parentRef = useRef(null);
	const scrollEndRef = useRef(onScrollEnd);
	scrollEndRef.current = onScrollEnd;
	const virtualizer = useVirtualizer({
		count: hasNextPage || isFetching ? items.length + 1 : items.length,
		getScrollElement: () => parentRef.current,
		estimateSize: () => 40,
		getItemKey: (index) => items[index]?.value ?? "loader_element",
		overscan: 5
	});
	const virtualItems = virtualizer.getVirtualItems();
	const lastVirtualItemIndex = virtualItems.at(-1)?.index;
	useEffect(() => {
		if (hasNextPage && !isFetching && lastVirtualItemIndex === items.length) scrollEndRef.current?.();
	}, [
		isFetching,
		hasNextPage,
		lastVirtualItemIndex,
		items.length
	]);
	const maxViewportPx = visibleItemsCount * ROW_HEIGHT_PX;
	const minViewportPx = minVisibleItemsCount ? Math.min(minVisibleItemsCount * ROW_HEIGHT_PX, maxViewportPx) : 0;
	const viewportHeightPx = Math.max(minViewportPx, Math.min(virtualizer.getTotalSize(), maxViewportPx));
	return /* @__PURE__ */ jsx(ScrollArea, {
		ref: parentRef,
		direction: "vertical",
		rootClassName: cn("w-full", className),
		style: {
			height: `${viewportHeightPx}px`,
			maxHeight: `${maxViewportPx}px`
		},
		children: /* @__PURE__ */ jsx("ul", {
			className: "relative w-full",
			style: { height: `${virtualizer.getTotalSize()}px` },
			children: virtualItems?.map((virtualItem) => {
				if (virtualItem.index === items.length) return /* @__PURE__ */ jsx("li", {
					"data-index": virtualItem.index,
					className: "absolute left-0 top-0 w-full",
					style: { transform: `translateY(${virtualItem.start}px)` },
					children: /* @__PURE__ */ jsx("div", {
						className: "flex h-10 cursor-progress items-center justify-center",
						children: /* @__PURE__ */ jsx(IconLoader, { className: "size-6 animate-spin" })
					})
				}, virtualItem.key);
				const item = items[virtualItem.index];
				if (!item) return null;
				return /* @__PURE__ */ jsx("li", {
					"data-index": virtualItem.index,
					className: "absolute left-0 top-0 w-full",
					style: { transform: `translateY(${virtualItem.start}px)` },
					children: /* @__PURE__ */ jsx(ListItem, {
						...item,
						search,
						fetchItemTooltip
					})
				}, virtualItem.key);
			})
		})
	});
};
//#endregion
export { List };

//# sourceMappingURL=List.js.map